import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion"; // Framer Motionをインポート

const HeroMessageContainer = styled.div`
  /* スクロールスナップの設定 */
  scroll-snap-align: start;
`;

const HeroMessageStyled = styled(motion.div).attrs({
  className: "u-text-center u-mb32",
})`
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;

  font-size: clamp(1.313rem, 0.849rem + 2.32vw, 2.5rem);
  line-height: 187.5%;
  letter-spacing: 0.75rem;

  text-align: justify;
  text-align-last: justify;
`;

const OsHeroMessage = () => {
  return (
    <HeroMessageContainer className="u-fullpage u-col-center u-items-center">
      <HeroMessageStyled
        initial={{ height: 0, opacity: 0 }} // 初期状態
        whileInView={{ height: "auto", opacity: 1 }} // スクロールで表示されたときの状態
        transition={{ duration: 1.5 }} // アニメーションの時間
        viewport={{ once: true, amount: 1 }} // 画面上から90%の位置でアニメーションを始動
      >
        異なる分野の
        <ruby>
          専門家<rt>スペシャリスト</rt>
        </ruby>
        を集めて
        <br />
        ひとつのプロジェクトを
        <br />
        進めるためのシステム
      </HeroMessageStyled>
    </HeroMessageContainer>
  );
};

export default OsHeroMessage;
